import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFeedStore } from '@/store/feed.store'

// Nav refactor: Events is no longer a separate feed lens — redirect to Local
// with the "event" Nível 2 chip pre-selected (SPEC_nav_menu_refactor.md).
export function EventsPage() {
  const navigate = useNavigate()
  const { setFeed, setSelectedTypes } = useFeedStore()
  useEffect(() => {
    setFeed('local')
    setSelectedTypes(['event'])
    navigate('/', { replace: true })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
